import { useSyncExternalStore } from "react";

/**
 * The internal-chat thread that is open full-screen (the app's Conversation
 * modal), from anywhere: a row in the Chat tab, a chat toast, an @-mention
 * popup (all of which call `requestOpenChat`). Drawn once by the layout's
 * thread host so it can open over any tab.
 */
export interface OpenThread {
  leadId: number;
  leadName?: string | null;
  childId?: number | null;
  messageId?: string | null;
}

let current: OpenThread | null = null;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach((fn) => fn());

export function openThread(t: OpenThread): void {
  current = t;
  notify();
}
export function closeThread(): void {
  if (!current) return;
  current = null;
  notify();
}
const subscribe = (fn: () => void) => {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
};
const get = () => current;
export function useOpenThread(): OpenThread | null {
  return useSyncExternalStore(subscribe, get, get);
}
